const routes = [
  {
    path: '/administracao/usuario',
    name: 'user',
    component: () => import('@/views/administracao/usuario/Usuario.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários' }] },
  },
  {
    path: '/administracao/usuario/novo',
    name: 'userNew',
    component: () => import('@/views/administracao/usuario/UsuarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/usuario/:id/editar',
    name: 'userUpdate',
    component: () => import('@/views/administracao/usuario/UsuarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/usuario/:idUser/grupos',
    name: 'userGroup',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioPai.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Grupos' }] },
  },
  {
    path: '/administracao/usuario/:idUser/grupos/novo',
    name: 'userGroupNew',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioNew.vue'),
    meta: {
      requiredPermission: 'user.edit',
      breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Grupos' }, { title: 'Novo' }],
    },
  },
  {
    path: '/administracao/usuario/:idUser/grupos/:id/editar',
    name: 'userGroupUpdate',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioNew.vue'),
    meta: {
      requiredPermission: 'user.edit',
      breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Grupos' }, { title: 'Editar' }],
    },
  },
  {
    path: '/administracao/usuario/:idUser/alocacoes',
    name: 'userAllocation',
    component: () => import('@/views/administracao/usuario/alocacaoUsuario/AlocacaoUsuarioPai.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Alocação' }] },
  },
  {
    path: '/administracao/grupo',
    name: 'group',
    component: () => import('@/views/administracao/grupo/Grupo.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Grupos' }] },
  },
  {
    path: '/administracao/grupo/novo',
    name: 'groupNew',
    component: () => import('@/views/administracao/grupo/GrupoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Grupos' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/grupo/:id/editar',
    name: 'groupUpdate',
    component: () => import('@/views/administracao/grupo/GrupoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Grupos' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/grupo/:id_group/regras',
    name: 'acl',
    component: () => import('@/views/administracao/grupo/acl/AclPai.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Grupos' }, { title: 'ACL' }] },
  },

  {
    path: '/administracao/programa',
    name: 'screen',
    component: () => import('@/views/administracao/programa/Programa.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Programa' }] },
  },
  {
    path: '/administracao/programa/novo',
    name: 'screenNew',
    component: () => import('@/views/administracao/programa/ProgramaNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Programa' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/programa/:id/editar',
    name: 'screenUpdate',
    component: () => import('@/views/administracao/programa/ProgramaNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Programa' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/log-acesso-usuario',
    name: 'userAccessLog',
    component: () => import('@/views/administracao/logAcesso/LogAcessoUsuario.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Logs de Acesso' }] },
  },
]

export default routes
